export const rolesToEnglish = {
  AGENT: "Administrator",
  ADMIN: "Owner",
};
